module.exports = __webpack_public_path__ + "static/img/icon_store_tab_content.45b658e.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_store_tab_content.png
// module id = AfA1
// module chunks = 1